class UnidadeMedida {
    constructor(
        {
            id = null,
            codigo = null,
            unidade_medida = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
        } = {}
    ) {
        this.id = id;
        this.codigo = codigo;
        this.unidade_medida = unidade_medida;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;
    }
}

export default UnidadeMedida;